import React, { useMemo, useEffect, useState } from "react";
import {
  DefaultColumnFilter,
  SelectColumnFilter,
  getCommonFilterTypes,
  StatusColumnFilter,
  CodStatusColumnFilter,
} from "../../../../helpers/commonTableFunctions";
import {
  useTable,
  usePagination,
  useFilters,
  useSortBy,
  useExpanded,
  useResizeColumns,
  // useAbsoluteLayout,
  // useBlockLayout,
  useFlexLayout,
} from "react-table";
import TablePagination from "../../../TablePagination";
import { format } from "date-fns";
import DeliveryMenuSelect from "./DeliveryMenuSelect";
import { Button, Modal } from "react-bootstrap";
// import { OrderDetailsPanel } from "./Orders/OrderDetailsPanel";
import { OrderDetailsPanelV2NewEndpoint } from "../../OrderDetailsPanelV2NewEndpoint";
import { BsDash, BsPlus } from "react-icons/bs";
import SortArrow from "../../../Utility/SortArrow";
import {
  accesses,
  orderHistoryPreFilters,
  orderStatuses,
  statusFilterMap,
  emails,
} from "../../../../constants";
import { isClient } from "../../../../services/accountService";
import LoadingSpinner from "../../../LoadingSpinner";
import { cn } from "../../../../helpers/cn";

const InvoicesModal = ({ show, handleCloseModal, invoices }) => {
  // console.log(show);
  // console.log(handleCloseModal);
  return (
    <Modal
      show={show}
      onHide={handleCloseModal}
      // dialogClassName="signature-modal"
    >
      <Modal.Header>
        <Modal.Title>Invoices</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ padding: 0 }}>
        <table className="table" style={{ margin: 0 }}>
          <thead>
            <tr>
              <th
                style={{ borderTop: "none", borderBottom: "1px solid #dee2e6" }}
              >
                Invoice Number
              </th>
              <th
                style={{
                  borderTop: "none",
                  borderBottom: "1px solid #dee2e6",
                  textAlign: "right",
                }}
              >
                Amount
              </th>
              {isClient() && (
                <th
                  style={{
                    borderTop: "none",
                    borderBottom: "1px solid #dee2e6",
                    textAlign: "right",
                  }}
                >
                  Insured
                </th>
              )}
            </tr>
          </thead>
          <tbody>
            {invoices.map((invoice, index) => {
              return (
                <tr key={index + "-" + invoice.invoiceNumber}>
                  <td>{invoice.invoiceNumber}</td>
                  <td style={{ textAlign: "right" }}>
                    {invoice.amount.toLocaleString("en-US", {
                      style: "currency",
                      currency: "USD",
                    })}
                  </td>
                  {isClient() && (
                    <td style={{ textAlign: "right", paddingRight: "2rem" }}>
                      {invoice.insured ? (
                        <span style={{ color: "black", fontSize: "1.3rem" }}>
                          &#128504;
                        </span>
                      ) : (
                        ""
                      )}
                    </td>
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-secondary" onClick={handleCloseModal}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
};

function OrderHistoryBodyRows({
  isLoading,
  isError,
  prepareRow,
  page,
  decodedClientInfo,
  visibleColumns,
  renderRowSubComponent,
}) {
  if (isLoading)
    return (
      <tr>
        <td
          colSpan={100}
          className="tw-h-72 tw-flex tw-items-center tw-justify-center"
        >
          <div className="tw-flex tw-flex-col tw-items-center tw-text-lg">
            <LoadingSpinner className="tw-h-8 tw-w-8" />
            Loading...
          </div>
        </td>
      </tr>
    );

  if (isError) {
    // const errorMessage =
    //   typeof isError === "string" ? (
    //     <div className="tw-text-center">
    //       {isError.includes("420, No orders") ? (
    //         isError.split(",")[1]
    //       ) : (
    //         <>
    //           {"" + isError}
    //           <br />
    //           If you believe this is unexpected, please contact Diligent
    //           Delivery support.
    //           <br />
    //           Support Email: {emails.supportEmail}
    //         </>
    //       )}
    //     </div>
    //   ) : (
    //     <div>Error loading order history. Please try again later.</div>
    //   );

    const errorMessage =
      typeof isError === "string" ? isError : JSON.stringify(isError);

    return (
      <tr>
        <td
          colSpan={100}
          className={cn(
            "tw-h-72 tw-flex tw-items-center tw-justify-center tw-text-lg  tw-font-medium tw-text-red-600"
          )}
        >
          <div className="tw-text-center">
            {errorMessage}
            <br />
            If you believe this is unexpected, please contact Diligent Delivery
            support.
            <br />
            Support Email: {emails.supportEmail}
          </div>
        </td>
      </tr>
    );
  }

  if (page?.length === 0) {
    return (
      <tr>
        <td>
          <div
            style={{
              padding: "150px",
              textAlign: "center",
              fontWeight: "600",
              color: "rgba(70,70,70)",
            }}
          >
            No results found.
            <br /> Make sure you searched the correct date range and that your
            filter values are correct.
          </div>
        </td>
      </tr>
    );
  }

  return page.map((row) => {
    prepareRow(row);

    return (
      <React.Fragment key={row.getRowProps().key}>
        <tr {...row.getRowProps()}>
          {row.cells.map((cell) =>
            cell.column.id !== "deliveryMenu" ||
            (cell.column.id === "deliveryMenu" &&
              (!isClient() ||
                decodedClientInfo[accesses.Deltrans] ||
                decodedClientInfo[accesses.IsMainAccount])) ? (
              <td className="multi-line" {...cell.getCellProps()}>
                {cell.render("Cell")}
              </td>
            ) : null
          )}
        </tr>
        {row.isExpanded && (
          <tr>
            <td
              style={{
                borderTopWidth: 0,
              }}
              colSpan={visibleColumns.length} //does not seem to matter with flex layout?
            >
              {renderRowSubComponent({ row })}
            </td>
          </tr>
        )}
      </React.Fragment>
    );
  });
}

const OrderHistoryTable = ({
  orders,
  onModifyClick,
  onVoidClick,
  onPrintLabelClick,
  onReturnRequestClick,
  onDeliveryConcernRequestClick,
  handleClickViewConcern,
  handleClickViewClaim,
  onPostClaimClick,
  decodedClientInfo,
  preFilter,
  handleChangePreFilter,
  expandRowEvent,
  loading,
  error: orderHistoryError,
}) => {
  const defaultColumn = React.useMemo(
    () => ({ Filter: DefaultColumnFilter }),
    []
  );

  const codStatusColumnFilterFunction = useMemo(
    () => (rows, ids, filterValue) => {
      //Using the default "equals" filtertype function as reference. (can be found here: https://github.com/TanStack/table/blob/v7/src/filterTypes.js)
      // export const equals = (rows, ids, filterValue) => {
      //   return rows.filter(row => {
      //     return ids.some(id => {
      //       const rowValue = row.values[id]
      //       // eslint-disable-next-line eqeqeq
      //       return rowValue == filterValue
      //     })
      //   })
      // }
      // equals.autoRemove = val => val == null
      //not sure what the above line is for

      //not sure how react-table handles the All(value="") option returning true for all rows? Maybe it doesn't even run the filter function if the filter value is ""
      return rows.filter((row) => {
        return ids.some((id) => {
          const rowValue = row.values[id];
          if (filterValue === "Yes") {
            return rowValue !== "No";
          }
          return rowValue == filterValue;
        });
      });
    },
    []
  );

  const statusColumnFilterFunction = useMemo(
    () => (rows, ids, filterValue) =>
      rows.filter((row) => {
        return ids.some((id) => {
          const rowValue = row.values[id];

          // console.log(filterValue);
          if (filterValue === orderStatuses.inTransit) {
            return statusFilterMap.inTransit.includes(rowValue);
          }
          if (filterValue === orderStatuses.delivered) {
            // Delivery Status can be "Delivered", "-Delivered-", or Delivered with Possible Exception(previously "Delivered*" and "Delivered**")
            // console.log(statusMap.delivered.includes(filterValue));
            return statusFilterMap.delivered.includes(rowValue);
          }
          if (filterValue === orderStatuses.possibleException) {
            return statusFilterMap.possibleException.includes(rowValue);
          }
          return rowValue === filterValue;
        });
      }),
    []
  );

  // console.log(decodedClientInfo);
  // console.log(accesses);

  //just going to add the bootstrap className's to ismael's filter inputs in ../helpers/commonTableFunctions.js
  // const CustomFilter = React.useMemo(() => {
  //   return ({ column }) => {
  //     // console.log("Customizing filter:");
  //     // console.log(column.filterValue);
  //     // console.log(column.setFilter);
  //     // console.log(column.preFilteredRows);
  //     return (
  //       <input
  //         className="form-control form-control-sm"
  //         placeholder={column.preFilteredRows.length + " records..."}
  //         value={column.filterValue}
  //         onChange={(e) => column.setFilter(e.target.value)}
  //       ></input>
  //     );
  //   };
  // }, []);

  //Was WIP, but just added the bootstrap classes to ismael's version
  // const CustomSelectFilter = React.useMemo(() => {
  //   return ({ column }) => {
  //     console.log(column);

  //     return (
  //       <select
  //         className="form-control form-control-sm"
  //         placeholder={column.preFilteredRows.length + " records..."}
  //         onChange={(e) => column.setFilter(e.target.value)}
  //       ></select>
  //     );
  //   };
  // });
  const [showInvoiceNumbersModal, setShowInvoiceNumbersModal] = useState(false);
  const [selectedInvoices, setSelectedInvoices] = useState([]);
  // console.log(showInvoiceNumbersModal);
  const handleOpenInvoiceNumbersModal = (
    invoiceNumbers,
    amounts,
    insuredInvoices
  ) => {
    //invoice numbers, cod amounts, insured boolean *SHOULD* be in sync
    let invoices = invoiceNumbers.map((invoiceNumber, index) => {
      return {
        invoiceNumber: invoiceNumbers[index],
        amount: amounts[index],
        insured: insuredInvoices[index],
      };
    });
    // console.log("SELECTED INVOICES:");
    // console.log(invoices);
    setSelectedInvoices(invoices);
    setShowInvoiceNumbersModal(true);
  };
  const handleCloseInvoiceNumbersModal = () => {
    setShowInvoiceNumbersModal(false);
  };

  const [filterByInsured, setFilterByInsured] = useState(false);
  const handleClickFilterByInsured = () => {
    setFilterByInsured((prev) => !prev);
  };

  const tableColumns = React.useMemo(
    () => [
      {
        // we are using this spot for a cdk order search button, acting as sort of a toggleable filter to see only cdk orders.
        Header: () => {
          return decodedClientInfo.IsCdkClient ? (
            <div className="m-0 p-0">
              {/* <button
                className={
                  "btn px-2 py-1 m-0" +
                  (filterByCDK ? " btn-primary" : " btn-secondary")
                }
                onClick={handleClickFilterByCDK}
              >
                CDK
              </button> */}
              Via
              <select
                className="form-control form-control-sm"
                value={preFilter}
                onChange={handleChangePreFilter}
              >
                <option value={orderHistoryPreFilters.All}>All</option>
                <option value={orderHistoryPreFilters.CDK}>CDK</option>
              </select>
            </div>
          ) : null;
        }, // No header
        id: "expander", // It needs an ID
        Cell: ({ row }) => (
          // Use Cell to render an expander for each row.
          // We can use the getToggleRowExpandedProps prop-getter
          // to build the expander.
          <span {...row.getToggleRowExpandedProps()}>
            {row.isExpanded ? (
              <Button variant="primary order-history-expander-button">
                <BsDash />
              </Button>
            ) : (
              <Button variant="primary order-history-expander-button">
                <BsPlus />
              </Button>
            )}
          </span>
        ),
        disableSortBy: true,
        disableFilters: true,
        width: 70,
      },
      {
        Header: "Delivery ID",
        accessor: "deliveryId",
        disableSortBy: true,
        width: 110,
        filter: "includesTrimmed",
      },
      {
        Header: (
          <div className="d-flex justify-content-between">
            Invoice Number
            {isClient() && (
              <div
                onClick={handleClickFilterByInsured}
                role="button"
                className={`order-history-invoice-insured-button ${
                  filterByInsured
                    ? "order-history-invoice-insured-button-toggled-on"
                    : ""
                }`}
              >
                Insured
              </div>
            )}
          </div>
        ),
        // accessor: "invoiceNumber",
        accessor: "invoiceNumbers",
        Cell: (rowData) => {
          // console.log(rowData);
          // if (rowData.value.length > 1) {
          //   console.log(rowData.value);
          // }
          // console.log("the row");
          // console.log(rowData.row.values.deliveryId);
          const value = rowData.value;
          // console.log(value);
          const amountToShow = 5;
          let invoiceChips = value
            .slice(0, amountToShow)
            .map((invoiceNumber, index) => {
              return (
                <div
                  key={index + "-" + invoiceNumber}
                  className={`order-history-invoice-chip ${
                    rowData.row.original.insuredInvoices[index] && isClient()
                      ? "order-invoice-history-chip-highlighted"
                      : ""
                  }`}

                  // style={{ fontSize: value.length === 1 ? "1rem" : ".7rem" }}
                >
                  {invoiceNumber}
                </div>
              );
            });
          if (value.length > amountToShow) {
            invoiceChips.push(
              <div
                key="see-more-chip" //why do we get a "each child in a list should have a unique key" warning without this, sometimes? Do you need a key even if it's not part of a .map
                className="order-history-invoice-chip order-history-invoice-chip-see-more"
              >
                + {value.length - amountToShow} more
              </div>
            );
          }
          return (
            <div
              className="clickable no-copy h-100"
              onClick={() => {
                handleOpenInvoiceNumbersModal(
                  rowData.value,
                  rowData.row.values.amounts,
                  rowData.row.original.insuredInvoices
                );
              }}
            >
              {invoiceChips}
            </div>
          );
        },
        disableSortBy: true,
        width: 215, //why is white space trimmed from between characters
        filter: "includesTrimmed",
      },
      {
        Header: "Delivery Date",
        accessor: "deliveryDate",
        Cell: ({ value }) => format(value, "MM/dd/yyyy"),
        disableFilters: true,
        sortType: "datetime",
        width: 90,
      },
      {
        Header: "Creation Date",
        accessor: "creationDate",
        Cell: ({ value }) => format(value, "MM/dd/yyyy hh:mma"),
        disableFilters: true,
        sortType: "datetime",
        width: 90,
      },
      {
        Header: isClient() ? "Customer" : "Dealer",
        accessor: (val) =>
          `${val.customerName}\n${val.customerAddress}\n${val.customerCity}, ${val.customerState} ${val.customerZip}\n${val.customerPhoneNumber}`,
        Cell: ({ value }) => {
          const arr = value.split("\n");

          return (
            <span>
              {arr[0]}
              <br />
              {arr[1]} | {arr[2]}
            </span>
          );
        },
        disableSortBy: true,
        width: 300,
        filter: "includesTrimmed",
      },
      {
        Header: "Route",
        accessor: "route",
        disableSortBy: true,
        width: 100,
        filter: "includesTrimmed",
      },
      {
        Header: "Pieces",
        accessor: "pieceCount",
        disableFilters: true,
        width: 60,
      },
      {
        Header: "COD",
        accessor: "codStatus",
        Filter: CodStatusColumnFilter,
        filter: codStatusColumnFilterFunction,
        disableSortBy: true,
        width: 90,
      },
      {
        Header: "Amount",
        accessor: "amounts",
        disableFilters: true,
        Cell: ({ value }) => {
          return value
            .reduce((rollingSum, amount) => {
              return (rollingSum += amount);
            }, 0)
            .toLocaleString("en-US", { style: "currency", currency: "USD" });
        },
        sortType: "number",
        width: 90,
      },
      {
        Header: "Delivery Type",
        accessor: "deliveryType",
        Filter: SelectColumnFilter,
        filter: "equals",
        disableSortBy: true,
        width: 120,
      },
      {
        Header: "Status",
        accessor: "status",
        disableSortBy: true,
        Filter: StatusColumnFilter,
        filter: statusColumnFilterFunction,
        width: 100,
        Cell: ({ value }) => {
          return value === "-Delivered-" ? (
            <i>Delivered</i>
          ) : value === "Delivered**" || value === "Exception" ? (
            "Delivered with Possible Exception"
          ) : (
            value
          );
        },
      },
      {
        //can i look at row.values[] for status?
        //insetad have hte deliveryMenu column be an object with id and status
        Header: () => <div style={{ textAlign: "center" }}>Options</div>,
        accessor: "deliveryMenu",
        Cell: ({ value }) => {
          return (
            //also have to pass in the data in "tableData" useMemo section further down in this component, and accept it as a prop in deliverymenuselect component
            <div style={{ textAlign: "center" }}>
              <DeliveryMenuSelect
                deliveryId={value.deliveryId}
                linkId={value.linkId}
                invoiceNumber={value.invoiceNumber}
                creationDate={value.creationDate}
                deliveryDate={value.deliveryDate}
                deliveryStatus={value.deliveryStatus}
                deliveryType={value.deliveryType}
                buyoutOrReturn={value.buyoutOrReturn}
                onModifyClick={onModifyClick}
                onVoidClick={onVoidClick}
                onPrintLabelClick={onPrintLabelClick}
                onReturnRequestClick={onReturnRequestClick}
                onDeliveryConcernRequestClick={onDeliveryConcernRequestClick}
                handleClickViewConcern={handleClickViewConcern}
                handleClickViewClaim={handleClickViewClaim}
                onPostClaimClick={onPostClaimClick}
                returnDeliveryId={value.returnDeliveryId}
                concernIncidentNo={value.concernIncidentNo}
                claimID={value.claimID}
                clientDoesNotAllowCustomerReturns={
                  value.clientDoesNotAllowCustomerReturns
                }
                returnRequestStatuses={value?.returnRequestStatuses}
              />
            </div>
          );
        },
        disableFilters: true,
        disableSortBy: true,
        width: 90,
        textAlign: "center",
      },
    ],
    [
      onVoidClick,
      onModifyClick,
      onPrintLabelClick,
      onReturnRequestClick,
      onDeliveryConcernRequestClick,
      preFilter,
      filterByInsured,
    ]
  );
  const tableData = useMemo(
    () =>
      orders
        .filter((order) => {
          return filterByInsured
            ? order.insured ||
                order.subInvoicesInsured.some((invoiceInsured) => {
                  return invoiceInsured;
                })
            : true;
        })
        .map((val) => {
          // console.log(val.status);
          // console.log(val.linkId);
          return {
            deliveryId: val.deliveryId,
            linkId: val.linkId,
            mainInvoiceNumber: val.invoiceNumber,
            invoiceNumbers: [val.invoiceNumber, ...(val.subInvoices ?? [])], //the main invoice number will be the first element (0) //also cdk orders do not currently have subinvoices so accounting for that by returning empty array
            deliveryDate: new Date(val.deliveryDate),
            creationDate: new Date(val.creationDate),
            customerName: val.customerName,
            customerAddress: val.customerAddress,
            customerCity: val.customerCity,
            customerState: val.customerState,
            customerZip: val.customerZip,
            customerPhoneNumber: val.customerPhoneNumber,
            route: val.route,
            pieceCount: val.pieceCount,
            isCod: val.isCod ? "Yes" : "No",
            codStatus: val.codStatus,
            mainInvoiceAmount: val.amount,
            amounts: [val.amount, ...(val.subAmounts ?? [])], //cdk orders do not currently have subinvoices/subamounts and we may have other types of orders in the future that do not, so returning an empty array to account for that.
            deliveryType: val.deliveryType,
            status: val.status,
            insured: val.insured || val.subInvoicesInsured?.some((val) => val),
            insuredInvoices: [val.insured, ...(val.subInvoicesInsured ?? [])],
            deliveryMenu: {
              deliveryId: val.deliveryId,
              linkId: val.linkId,
              invoiceNumber: val.invoiceNumber,
              creationDate: new Date(val.creationDate),
              deliveryDate: new Date(val.deliveryDate),
              deliveryStatus: val.status,
              deliveryType: val.deliveryType,
              buyoutOrReturn:
                val.deliveryType === "Buy Out" || val.deliveryType === "Return",
              returnDeliveryId: val.rtntrn,
              concernIncidentNo: val.csrtrn,
              claimID: val.clmtrn,
              clientDoesNotAllowCustomerReturns: val.excluded,
              isCod: val.isCod,
              returnRequestStatuses: val.returnRequestStatuses,
            },
          };
        }),
    [orders, filterByInsured]
  );

  //reset custom filtering if the original orders change (when the search is resubmitted)
  useEffect(() => {
    setFilterByInsured(false);
  }, [orders]);

  const filterTypes = React.useMemo(
    () => ({
      ...getCommonFilterTypes(),
    }),
    []
  );

  const renderRowSubComponent = React.useCallback(
    // ({ row }) => (
    //   <DeliveryDetailsSlim
    //     deliveryId={row.values["deliveryId"]}
    //     invoiceNumber={row.values["invoiceNumber"]}
    //     orderDate={row.values["creationDate"]}
    //   />
    // ),
    ({ row }) => {
      return (
        <>
          {/* <OrderDetailsPanel
            deliveryId={row.values["deliveryId"]}
            mainInvoiceNumber={row.values["invoiceNumbers"][0]} //pass the main invoice number to detail panels, as we will append this to file names for the POD downloads
            orderCreationDate={row.values["creationDate"]}
            orderStatus={row.values["status"]}
            isCod={row.original["isCod"]}
          /> */}
          {/* {console.log(row)} */}
          <OrderDetailsPanelV2NewEndpoint
            mainOrderDataRaw={row.original}
            deliveryId={row.values["deliveryId"]}
            mainInvoiceNumber={row.values["invoiceNumbers"][0]} //pass the main invoice number to detail panels, as we will append this to file names for the POD downloads
            orderCreationDate={row.values["creationDate"]}
            orderStatus={row.values["status"]}
            isCod={row.original["isCod"]}
          />
        </>
      );
    },
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    rows,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    pageCount,
    previousPage,
    setPageSize,
    visibleColumns,
    state: { pageIndex, pageSize },
    toggleSortBy,
    sortedIndex,
    toggleAllRowsExpanded,
  } = useTable(
    {
      columns: tableColumns,
      data: tableData,
      defaultColumn,
      filterTypes,
    },
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useFlexLayout,
    useResizeColumns
  );

  //used to expand the first row when searching by invoice
  useEffect(() => {
    // console.log(page);
    //expandRowEvent is initialized at 0 and will go up whenever they search by invoice
    if (page.length > 0 && expandRowEvent > 0) {
      page[0].toggleRowExpanded();
    }
  }, [expandRowEvent]);

  useEffect(() => {
    toggleSortBy("creationDate", true, false);
  }, [toggleSortBy, tableData]);

  const handleResetExpanders = (e) => {
    toggleAllRowsExpanded(false);
  };
  // useEffect(() => {
  //   setTimeout(() => {
  //     toggleAllRowsExpanded(false);
  //     console.log(toggleAllRowsExpanded);
  //   }, 6000);
  // }, []);
  // useEffect(() => {
  //   const fetchGetParcelsEndpoint = async () => {
  //     try {
  //       const response = await axios.get(
  //         "https://localhost:44354/api/Delivery/GetParcel?barcode=1229485001"
  //       );
  //       const data = await response.data;
  //       console.log(data);
  //     } catch (ex) {
  //       console.log(ex);
  //     }
  //   };
  //   console.log("GET PARCEL BY BARCODE ENDPOINT");
  //   fetchGetParcelsEndpoint();
  // }, []);

  //Based off testing in ForLoopVsReduceTest.js, doing a for loop is slightly faster (Don't really think its enough of a difference to matter, but I just want to make sure that filtering is as unlaggy as possible because it kind of is (when erasing a filter by holding backspace)).
  // const summary = rows.reduce(
  //   (sumObject, row) => {
  //     if (row.original.status === "Open") {
  //       return {
  //         open: sumObject.open + 1,
  //         inTransit: sumObject.inTransit,
  //         outForDelivery: sumObject.outForDelivery,
  //         delivered: sumObject.delivered,
  //       };
  //     } else if (row.original.status === "In Transit") {
  //       return {
  //         open: sumObject.open,
  //         inTransit: sumObject.inTransit + 1,
  //         outForDelivery: sumObject.outForDelivery,
  //         delivered: sumObject.delivered,
  //       };
  //     } else if (row.original.status === "Out for Delivery") {
  //       return {
  //         open: sumObject.open,
  //         inTransit: sumObject.inTransit,
  //         outForDelivery: sumObject.outForDelivery + 1,
  //         delivered: sumObject.delivered,
  //       };
  //     } else if (row.original.status === "Delivered") {
  //       return {
  //         open: sumObject.open,
  //         inTransit: sumObject.inTransit,
  //         outForDelivery: sumObject.outForDelivery,
  //         delivered: sumObject.delivered + 1,
  //       };
  //     }
  //   },
  //   {
  //     open: 0,
  //     inTransit: 0,
  //     outForDelivery: 0,
  //     delivered: 0,
  //   }
  // );
  // console.log(summary);
  //See which statuses we got back and how many
  // console.log(
  //   rows.reduce((rolling, current) => {
  //     let newObject = { ...rolling };
  //     console.log(rolling);
  //     if (newObject[current.original.status]) {
  //       newObject[current.original.status] =
  //         newObject[current.original.status] + 1;
  //     } else {
  //       newObject[current.original.status] = 1;
  //     }
  //     return newObject;
  //   }, {})
  // );

  let summary = {
    open: 0,
    // pickedUp: 0,
    inTransit: 0,
    outForDelivery: 0,
    partialDelivery: 0,
    delivered: 0,
    deliveredItalics: 0,
    deliveredStar: 0,
    deliveredStarStar: 0,
  };
  for (let i = 0; i < rows.length; i++) {
    if (statusFilterMap.open.includes(rows[i].original.status)) {
      summary.open += 1;
    } else if (statusFilterMap.inTransit.includes(rows[i].original.status)) {
      summary.inTransit += 1;
    } else if (
      statusFilterMap.outForDelivery.includes(rows[i].original.status)
    ) {
      summary.outForDelivery += 1;
    } else if (
      statusFilterMap.partialDelivery.includes(rows[i].original.status)
    ) {
      summary.partialDelivery += 1;
    } else if (
      statusFilterMap.delivered.includes(rows[i].original.status) ||
      statusFilterMap.possibleException.includes(rows[i].original.status)
    ) {
      summary.delivered += 1;
    }
  }

  return (
    <>
      <InvoicesModal
        show={showInvoiceNumbersModal}
        handleCloseModal={handleCloseInvoiceNumbersModal}
        invoices={selectedInvoices}
      />
      <div className="border-top">
        <div className="row text-center container m-auto">
          <div className="col-md-3">Open Orders: {summary.open}</div>
          <div className="col-md-3">In Transit Orders: {summary.inTransit}</div>
          <div className="col-md-3">
            Out for Delivery Orders: {summary.outForDelivery}
          </div>
          <div className="col-md-3">
            Delivered Orders:{" "}
            {summary.delivered +
              summary.deliveredItalics +
              summary.deliveredStar +
              summary.deliveredStarStar +
              summary.partialDelivery}
            {/* <br />
            Delivered Orders Italics: {summary.deliveredItalics}
            <br />
            Delivered Orders Star: {summary.deliveredStar} */}
          </div>
        </div>
      </div>
      <div className="table-responsive order-history-table-container">
        <table className="table col-12" {...getTableProps()}>
          <thead className="order-history-table-header">
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => {
                  const columnHeaderProps = column.getHeaderProps(
                    column.getSortByToggleProps()
                  );

                  // console.log(column.id);
                  return column.id !== "deliveryMenu" || //We want to render the Options column conditionally. If the column isn't the Options column, render it.
                    (column.id === "deliveryMenu" && //if it is the Options column, check to see if we have Deltrans access or are the main account, maybe make access check functions or something and check for admin as well but that field is based on all the rest being true
                      (!isClient() ||
                        decodedClientInfo[accesses.Deltrans] ||
                        decodedClientInfo[accesses.IsMainAccount])) ? (
                    <th //we must do the same logic for the row part of this below, this part is to conditionally render the headers.
                      className="order-history-th"
                      {...columnHeaderProps}
                      onClick={(e) => {
                        // console.log(columnHeaderProps);
                        // console.log(column);
                        // console.log(columnHeaderProps.onClick);
                        // console.log(columnHeaderProps);
                        // console.log(headerGroup.getHeaderGroupProps());
                        // console.log(column.getSortByToggleProps());
                        // console.log(column.getHeaderProps());

                        //we are resetting the expanded rows because sometimes when an expanded is brought back onto the visible rows through sorting/filtering, it will send out a network request that will return an error. Not sure why this is happening.
                        //unexpand all rows when the table is sorted differently
                        columnHeaderProps.title === "Toggle SortBy" &&
                          handleResetExpanders();
                        columnHeaderProps.onClick &&
                          columnHeaderProps.onClick(e);
                      }}
                      onChange={(e) => {
                        //also
                        //for columns that have inputs/select menus to filter.
                        handleResetExpanders();
                      }}
                    >
                      {column.render("Header")}
                      {column.Header === "Amount" ? <br /> : null}
                      {column.canFilter && column.render("Filter")}
                      {column.canSort && (
                        <SortArrow
                          isSorted={column.isSorted}
                          isSortedDesc={column.isSortedDesc}
                        />
                      )}
                    </th>
                  ) : null;
                })}
              </tr>
            ))}
          </thead>

          <tbody {...getTableBodyProps()}>
            <OrderHistoryBodyRows
              isLoading={loading}
              isError={orderHistoryError}
              prepareRow={prepareRow}
              page={page}
              decodedClientInfo={decodedClientInfo}
              visibleColumns={visibleColumns}
              renderRowSubComponent={renderRowSubComponent}
            />
          </tbody>
        </table>
      </div>
      <div className="col-12">
        <TablePagination
          onPreviousPageClick={() => {
            handleResetExpanders();
            previousPage();
          }}
          onNextPageClick={() => {
            handleResetExpanders();
            nextPage();
          }}
          canPreviousPage={canPreviousPage}
          canNextPage={canNextPage}
          gotoPage={(val) => {
            handleResetExpanders();
            gotoPage(val);
          }}
          pageIndex={pageIndex}
          pageOptions={pageOptions}
          pageSize={pageSize}
          pageCount={pageCount}
          setPageSize={(e) => setPageSize(Number(e.target.value))}
        />
      </div>
    </>
  );
};

export default OrderHistoryTable;
